import { Type } from "class-transformer";
import { observable } from "mobx";

export default class ValidChargeResponse {
  @observable chargeId: string;
  @observable chargeTypeId: string;
  @Type(() => Date)
  @observable
  validSince: Date;
  @Type(() => Date)
  @observable
  validUntil: Date;
  @observable isOverlapped: boolean;
}
